<div class="d-flex justify-content-center">
  <div class="comment">
    {{comment}}
  </div>
</div>
